export default "__VITE_ASSET__BjgN0nxx__"